module.exports = __webpack_public_path__ + "img/custom-1.d375f40.png";